<mat-card>
  <app-card-header
    [title]="'Historial de eventos'"
    icono="history"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="heg-tabla">
      <app-tabla
        [name]="name"
        [columnas]="columnas"
        [datos]="eventosHistorico"
        [totalCount]="totalCount"
        [(query)]="query"
        (listar)="listar()"
      ></app-tabla>
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
